(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1025px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('scroll', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  $('.lookbook-carousel-slider').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    arrows: true,
    variableWidth: true,
    accessibility: true,
    prevArrow:"<button type='button' class='slick-prev slick-arrow'><svg width='31' height='25' viewBox='0 0 31 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M7.5 19.8118L8.73375 18.578L3.85125 13.6868L30.5 13.6868L30.5 11.9368L3.85125 11.9368L8.7425 7.05427L7.5 5.81177L0.500001 12.8118L7.5 19.8118Z' fill='currentColor'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next slick-arrow'><svg width='31' height='25' viewBox='0 0 31 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M23.5 5.81177L22.2663 7.04552L27.1488 11.9368L0.5 11.9368V13.6868L27.1488 13.6868L22.2575 18.5693L23.5 19.8118L30.5 12.8118L23.5 5.81177Z' fill='currentColor'/></svg></button>",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false
        }
      }
    ]
  });

  $('.lookbook-carousel-autoplauy').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    arrows: true,
    variableWidth: true,
    accessibility: true,
    prevArrow:"<button type='button' class='slick-prev slick-arrow'><svg width='31' height='25' viewBox='0 0 31 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M7.5 19.8118L8.73375 18.578L3.85125 13.6868L30.5 13.6868L30.5 11.9368L3.85125 11.9368L8.7425 7.05427L7.5 5.81177L0.500001 12.8118L7.5 19.8118Z' fill='currentColor'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next slick-arrow'><svg width='31' height='25' viewBox='0 0 31 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M23.5 5.81177L22.2663 7.04552L27.1488 11.9368L0.5 11.9368V13.6868L27.1488 13.6868L22.2575 18.5693L23.5 19.8118L30.5 12.8118L23.5 5.81177Z' fill='currentColor'/></svg></button>",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 1000
        }
      }
    ]
  });

  function updateTabIndex() {
    $('.lookbook-item-image[aria-hidden="true"] a, .lookbook-item-image[aria-hidden="true"] button, .lookbook-item-image[aria-hidden="true"] input, .lookbook-item-image[aria-hidden="true"] select, .lookbook-item-image[aria-hidden="true"] textarea').attr('tabindex', '-1');
  }

  // Initial update
  updateTabIndex();

  // Update tabindex whenever the slide changes
  $('.lookbook-item-image').on('afterChange', function(event, slick, currentSlide, nextSlide){
    updateTabIndex();
  });

  let matchMedia = window.matchMedia("(max-width:767px)");
  if (matchMedia.matches) {
    $('.lookbook-carousel-settings').slick('slickRemove', 0);
  }

  $('.slick-prev').attr('aria-label', 'Previous Slide');
  $('.slick-next').attr('aria-label', 'Next Slide');
});

  } catch(e) { console.error(e); }
})();
})();
